<div class="flex flex-col min-h-[75vh]">
    <!-- Banner -->
    <magic-deck-banner [deck]="deck" [deckComponent]="this" class="w-full card-shadow"></magic-deck-banner>
    <!-- Content -->
    <div class="items-center md:items-start flex flex-col gap-4 sm:mt-4 sm:pb-4 grow">
        <div class="flex flex-row items-center justify-center w-full">
            <!-- Deck Content -->
            <div #deckContents class="flex flex-col gap-4 lg:flex-row lg:items-start" [ngClass]="{ 'w-full' : isMobileScreen() }">
                <!-- Focused Card -->
                @if (!isMobileScreen()) {
                    <div #focusedCardContainer class="relative">
                        <deck-focused-card class="hidden lg:block" [focusedCard]="focusedCard"></deck-focused-card>
                    </div>
                }
                <!-- Deck Cards -->
                <div class="flex flex-col sm:grow w-full items-center sm:items-start">
                    <!-- Tabs and Edit -->
                    <deck-tabs [deck]="deck" [deckComponent]="this" [currentLayer]="currentLayer" class="w-full"></deck-tabs>
                    
                    <!-- Layer Content -->
                    <div class="flex flex-col items-center md:items-start pt-4 pl-0 pr-0 sm:pl-4 sm:pr-4 min-w-[428px] md:min-w-[861px] 2xl:min-w-[1284px]">
                        <ng-template #deckLayers></ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Deck Charts -->
    <div class="flex flex-col md:flex-row justify-center gap-8 sm:gap-4 p-8 pb-0 border-t border-b border-dashed bg-slate-100 bg-opacity-50 border-slate-300 border-opacity-60">
        <magic-mana-curve-chart [deck]="deck" [deckComponent]="this" class="pb-8 border-b border-slate-300 sm:border-0"></magic-mana-curve-chart>
        <magic-color-pie-chart [deck]="deck" [deckComponent]="this" class="pb-8 border-b border-slate-300 sm:border-0"></magic-color-pie-chart>
        <magic-mana-produced-pie-chart [deck]="deck" [deckComponent]="this" class="pb-8"></magic-mana-produced-pie-chart>
    </div>
    <!-- Hand Simulator -->
    <div class="flex flex-col md:flex-row justify-center gap-8 sm:gap-4 p-8 bg-slate-100">
        <magic-hand-simulator [deck]="deck" [deckComponent]="this"></magic-hand-simulator>
    </div>
</div>
<!-- Single highlight preset colors definition used by the card dialog. -->
<datalist id="highlightPresetColors">
    <option>#ffc9c9</option>
    <option>#ffd6a8</option>
    <option>#A8DEBB</option>
    <option>#b8e6fe</option>
    <option>#ddd6ff</option>
    <option>#62748e</option>
    <option>#90a1b9</option>
    <option>#cad5e2</option>
    <option>#f1f5f9</option>
    <option>#ffffff</option>
</datalist>